import { render, staticRenderFns } from "./LogoHeart.vue?vue&type=template&id=3467bcbd"
var script = {}
import style0 from "./LogoHeart.vue?vue&type=style&index=0&id=3467bcbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports